import log from 'Utilities/log';
import { clearCookie, clearSession, getSessionObject, setSessionObject } from 'Utilities/storage';
import mediator from './mediator';
export const persistAuthSession = session => {
  try {
    setSessionObject('authSession', session);
  } catch (err) {
    log.error(err);
  }
};
export const getAuthSession = () => {
  try {
    const authSession = getSessionObject('authSession');
    return authSession;
  } catch (e) {
    return null;
  }
};
export const updateSessionLanguage = language => {
  setSessionObject('language', language);
};
export const getSessionLanguage = () => {
  return getSessionObject('language');
};
export const logout = () => {
  clearSession();
  clearCookie('authSession');
  mediator.publish('router:navigate', '/login');
};